import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
// *ngIf, *ngFor [ngClass], [ngStyle]
import { FormsModule } from '@angular/forms';
import liff from '@line/liff';
import { CookieService } from 'ngx-cookie-service';
import { LiffService } from '../../../core/services/liff.service';
import { ToastNotifService } from '../../../core/services/toastNotif.service';
import { StatusAPIResponse } from '../../../core/models/information.model';
import { LanguageService } from '../../../core/services/language.service';
import { ApiInviteService } from '../../../core/services/api/Invite/api-invite';
@Component({
  selector: 'app-register',
  imports: [CommonModule, FormsModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css',
})
export class RegisterComponent implements OnInit {
  isButton: boolean = false; // เปลี่ยนเป็น true เมื่อกรอกครบ
  error: string = ''; // มี error จะปิดปุ่ม
  phoneNo: string = '';
  isFormValid: boolean = false;
  isModalOpen: boolean = false;
  lineUid: string = '';
  displayName: string = '';
  pictureUrl: string = '';
  codeInvite: string = '';
  codeInvites : string = '';
  agree: boolean = false;
  isLoading: boolean = false;
  currentLang: string = 'TH';
  url: string =
    'https://profile.line-scdn.net/0h-LGTM-GtcmNqLWOw7-0MHBp9cQlJXCtxRE00AFt5JFJTTmcxRBs_BV4qL1ZRFTYyE04_DQoqKQBmPgUFdHuOV20dL1JWGzU0RUI9gw';
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private liffService: LiffService,
    private apiInviteService: ApiInviteService,
    private toast: ToastNotifService,
    private languageService: LanguageService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  async ngOnInit() {
    this.lineUid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    this.displayName =
      this.cookieService.get('display_name') ||
      localStorage.getItem('display_name') ||
      '';
    this.pictureUrl =
      this.cookieService.get('picture_url') ||
      localStorage.getItem('picture_url') ||
      '';

    this.codeInvite =
      this.cookieService.get('ref_code') ||
      localStorage.getItem('ref_code') ||
      '';

    await this.liffService.initLiff(); // เปิดนะ

    // const response = await this.liffService.checkRegister();
    // if (response && response.code === '000') {
    //   // 🎯 ลงทะเบียนแล้ว → เซ็ต cookie + redirect
    //   this.cookieService.set('login_status', 'logged_in');
    //   this.cookieService.set('token_user', response.token);
    //   this.router.navigate(['/home']);
    // } else {
    //   // 🟡 ยังไม่ได้ลงทะเบียน → ปล่อยให้ลงทะเบียนต่อ
    //   console.log('🟡 User not registered, stay on register page');
    // }
  }
  changeLanguage(lang: string) {
    this.currentLang = lang;
    console.log('เปลี่ยนภาษาเป็น:', this.currentLang);
  }
  handleCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    console.log('checkbox checked:', checked);
    // เพิ่ม logic ได้ที่นี่ เช่น เก็บค่าไว้ใน form
  }

  validateForm() {
    const phoneValid = /^0[0-9]{9}$/.test(this.phoneNo);
    this.error = phoneValid ? '' : 'เบอร์ไม่ถูกต้อง';
    this.isButton = phoneValid && this.agree; // ติ๊ก checkbox แล้ว + เบอร์ถูก
  }

  filterNumberOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.phoneNo = input.value;
  }

  handleOnclick() {
    console.log('Code' , this.codeInvite);
    console.log('Phone' , this.phoneNo);

    if (this.codeInvite.trim()) {
      console.log('Check codeInvite');
      this.isLoading = true;
      this.apiInviteService.checkInviteCode(this.codeInvite).subscribe({
        next: (response: StatusAPIResponse) => {
          this.isLoading = false;
          if (response.code === '000') {
            this.goOTPPage();
          } else {
            this.toast.error('รหัสคำเชิญไม่ถูกต้อง');
          }
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
    } else {
      console.log('No Invite Code');
      this.goOTPPage();
    }
  }

  goOTPPage() {
    this.router.navigate(['/verify-otp'], {
      queryParams: { phone: this.phoneNo, invite: this.codeInvite },
    });
  }

  closeModal() {
    this.isModalOpen = false;
  }
  openModal() {
    this.isModalOpen = true;
  }
}
